var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"py-4 card-text mb-5"},[_vm._v("\n    Creative Logo\n  ")]),_c('logo-upload',{attrs:{"logo-type":"unit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }